import { Outlet } from 'react-router'
import { ButtonBrandLegacy } from '@/components/ui/button-brand-legacy'
import { ButtonLinkLegacy } from '@/components/ui/button-link-legacy'
import { useAuthStore } from '@/features/auth/store/store'
import { CsvUploadDialog } from '@/features/luxe-submissions/components/csv-upload-dialog'
import { getLuxeRedirectPath } from '@/features/luxe-submissions/utils'
import { routes } from '@/routes'
import { useTranslation } from '@/translations/i18n'

function LuxeSubmissionsCsvUploadsLayout() {
	const { t } = useTranslation()
	const user = useAuthStore((state) => state.user)

	return (
		<div className='flex flex-1 flex-col overflow-hidden'>
			<div className='flex items-center justify-between border-neutral-200 border-b px-10 pt-6 pb-6'>
				<div className='flex items-center gap-1'>
					<h1 className='font-medium text-lg text-neutral-900'>
						{t('luxe_submissions:csv_uploads_title')}
					</h1>
					<p className='text-base text-neutral-600'>
						{t('luxe_submissions:csv_uploads_subtitle')}
					</p>
				</div>

				<div className='flex gap-4'>
					<ButtonLinkLegacy
						size='sm'
						to={
							getLuxeRedirectPath(user?.role) ??
							routes.LUXE_SUBMISSIONS_MM_SUBMISSIONS.handle
								.fullPath
						}
						variant='outline'
					>
						{t('luxe_submissions:back_to_overview')}
					</ButtonLinkLegacy>

					<CsvUploadDialog
						trigger={
							<ButtonBrandLegacy size='sm' type='button'>
								{t('luxe_submissions:csv_uploads_upload_file')}
							</ButtonBrandLegacy>
						}
					/>
				</div>
			</div>

			<div className='flex flex-1 flex-col overflow-hidden'>
				<Outlet />
			</div>
		</div>
	)
}

export { LuxeSubmissionsCsvUploadsLayout }
